export const SPEECH_CHECK_PASSAGES = [
    {
        // (a) plain workplace narrative — the baseline register the interview mostly runs in.
        id: "everyday-work",
        label: "Everyday work",
        text: "Last week our team finished the quarterly report two days early. I shared the final copy " +
            "with my manager, and she asked me to present the summary in Monday's meeting. We spent the " +
            "afternoon checking the numbers together, fixed two small mistakes, and sent the deck to the " +
            "client before leaving the office.",
    },
    {
        // (b) Indian-workplace vocabulary — the terms and names our candidates actually say, and
        // exactly where a US-trained acoustic model tends to fall over.
        id: "indian-workplace",
        label: "Workplace vocabulary",
        text: "Priya Sharma is serving her notice period in Chennai before she joins the Pune office. " +
            "Arjun from the Gurgaon team will handle the shift handover and the pending reconciliation. " +
            "If the escalation is not closed this week, Lakshmi wants a call with Mohammed from HR to " +
            "discuss her CTC revision and the transfer letter.",
    },
    {
        // (c) numbers, dates, amounts — transcription formatting is noisiest here, and interview
        // answers about salary, targets and dates depend on it. "48,500 rupees" (not "₹48,500") so
        // every reader says it in the same order and we measure the ENGINE, not reading order.
        id: "numbers-amounts",
        label: "Numbers and dates",
        text: "The invoice for March was 48,500 rupees, and the advance of 12,000 rupees was adjusted in " +
            "April. Sales grew 14% in the first quarter and 9% in the second. My alternate number is " +
            "98401 23456, and the meeting moved from the 21st of June to the 3rd of July.",
    },
];
/** Canonical text by id — what the server scores against, whatever the wire claimed. */
export function speechCheckReference(passageId) {
    return SPEECH_CHECK_PASSAGES.find((p) => p.id === passageId)?.text ?? null;
}
//# sourceMappingURL=speechCheckPassages.js.map